// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "src_ts_oldCode_satisfaction-file_js") return "app.ts.satisfaction-file.js";
	if (chunkId === "src_ts_service_hub_ts") return "app.hub.pkpxS.js";
	if (chunkId === "src_ts_entries_videoBlock_videoBlock_tsx") return "app.videoBlock.pkpxS.js";
	if (chunkId === "src_ts_components_messages_globalMessage_tsx") return "app.globalMessage.pkpxS.js";
	if (chunkId === "src_ts_components_newsletter_newsletterForm_tsx") return "app.newsletterForm.pkpxS.js";
	if (chunkId === "src_ts_entries_tracking_ts") return "app.tracking.pkpxS.js";
	if (chunkId === "src_ts_entries_basketAmount_tsx") return "app.basketAmount.pkpxS.js";
	if (chunkId === "node_modules_oj-mithriljs-packages_dist_FileUpload_FileUpload_js") return "oj-mithriljs-packages.dist.FileUpload.FileUpload.js.dist.js";
	// return url for filenames based on template
	return undefined;
};